import api from "./api";
import config from "../config";

export default {
  async getReminders() {
    return await api.get(`${config.url.api}/v1/settings/0/reminder`);
  },

  // Mailvarianten (ADR-0112). Elke aanroep geeft de opgeslagen variant terug.
  async createMailVariant(payload) {
    const res = await api.put(`${config.url.api}/v1/settings/0/mail_variant`, payload);
    return res.data.success;
  },

  async updateMailVariant(id, payload) {
    const res = await api.patch(`${config.url.api}/v1/settings/${id}/mail_variant`, payload);
    return res.data.success;
  },

  async deleteMailVariant(id) {
    const res = await api.delete(`${config.url.api}/v1/settings/${id}/mail_variant`);
    return res.data.success;
  },
};
